import { Injectable } from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions} from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';

import { StorageService } from '../../shared/services/storage.service';
import { ErrorService } from '../../shared/services/error.service';
import { PopupService } from '../../shared/services/pop-up.service';

@Injectable()
export class NceAdminService{

    vTotalData: number = 0;
    vLoadingStatus: boolean;
    
    vNCELists: Array<{
        nce_record_id: number,
        nce_request_id: string,
        create_date: string,
        updated_date: string,
        location_earthwork: string,
        appointment_date: string,
        appointment_time: string,
        status: string
    }>;

    vAllStatus: Array<{
        status: string,
        description: string
    }>

    constructor(
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _popupService: PopupService
    ) {
        this.vLoadingStatus = false;
    }

    getTotalData(){
        return this.vTotalData;
    }

    getNCEList(){
        return this.vNCELists;
    }

    getAllNceStatus(){
        return this.vAllStatus;
    }

    isLoading(){
        return this.vLoadingStatus;
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    loadAllNCEStatus(){
        let data = this._storageService.getSessionItem('allNCEAdminStatus');
        if(data !== null){
            this.vAllStatus = JSON.parse(data);
        }
        else{ 
            this._http.get(API_ENDPOINTS.NCE_ADMIN.GET_ALL_STATUS).subscribe(
                (response) => {
                    let vResponseData:any = response;
                    console.log(vResponseData);
                    this.vAllStatus = vResponseData.data.status;
                    this._storageService.setSessionItem('allNCEAdminStatus', JSON.stringify(this.vAllStatus));
                },
                (error) => {
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            );
        }
    }


    loadNCE(pPageNumber, pPageSize, pSearchBy, pFilterBy, pNCEStatus){
        var promise = this._http.get(API_ENDPOINTS.NCE_ADMIN.GET_ALL_NCE + '?page_number=' + pPageNumber + '&page_size=' + pPageSize+'&search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pNCEStatus);

        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vNCELists = vResponseData.data.nceapplications;
                resolve();
            },
            error  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    getLinkCSV(pSearchBy, pFilterBy, pNCEStatus){
        var promise = this._http.get(API_ENDPOINTS.NCE_ADMIN.GET_LINK_CSV + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pNCEStatus);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                let vResponseData:any = response;
                console.log(vResponseData.data.downloadLink);
                resolve(vResponseData.data.downloadLink);
            },
            error  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    getDetailLinkCSV(pNceRecordID){
        let xData = {
            nce_record_id: pNceRecordID
        };
        var promise = this._http.post(API_ENDPOINTS.NCE_ADMIN.GET_DETAIL_LINK_CSV, xData);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                let vResponseData:any = response;
                console.log(vResponseData.data.downloadLink);
                resolve(vResponseData.data.downloadLink);
            },
            error  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadTotalData(pSearchBy, pFilterBy, pNCEStatus){
        var promise = this._http.get(API_ENDPOINTS.NCE_ADMIN.GET_TOTAL_NCE + '?search_by=' + pSearchBy + '&filter_by=' + pFilterBy + '&status=' + pNCEStatus);

        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vTotalData = vResponseData.data.total_nceapplications;
                resolve();
            },
            error  => {
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    updateStatus(pNceRecordID, pStatus, pIsRejection?, pRemarks?){
        let xData = {
            nce_record_id: pNceRecordID,
            status: pStatus,
            rejectDocument: pIsRejection,
            remarks: pRemarks || '',
        }
        var promise = this._http.post(API_ENDPOINTS.NCE_ADMIN.UPDATE_STATUS, xData);
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    changeAppointment(pNCEID, pSelectedDate, pselectedTime){
        let xData = {
            nce_record_id: pNCEID,
            appointment_date: pSelectedDate.getFullYear() + '' + ("0" + (pSelectedDate.getMonth() + 1)).slice(-2) + '' + ("0" + pSelectedDate.getDate()).slice(-2),
            appointment_time: pselectedTime
        }
        this.vLoadingStatus = true;
        var promise = this._http.post(API_ENDPOINTS.NCE_ADMIN.CHANGE_APPOINTMENT, xData);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                resolve();
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce-admin/services/nce-admin.service.ts